import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import { useAuth } from '../../../../../app/modules/auth'
import { ROLES } from '../../../../../app/routing/PrivateRoutes'
import { useLayout } from '../../../core'

export function MenuInner() {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const roleId:number = +currentUser?.role_id!
  const menuItemList = [] 
  return (
    <>
      {/* {menuItemList.map((menu) => { 
        if (menu.allowedRoles.includes(roleId)) { 
          if((menu.submenu ?? []).length > 0){
            return <MenuInnerWithSub 
              key={menu.title}
              title={menu.title} to={menu.to||''} 
              hasArrow={true}
              menuPlacement='bottom-start'
              menuTrigger="{default:'click', lg: 'hover'}"
            >
              {menu.submenu?.map((submenu)=>{
                return <MenuItem key={submenu.title} title={submenu.title} to={submenu.to||''} hasBullet={true} refresh={true}/>; 
              })}
            </MenuInnerWithSub>            
          }
          return <MenuItem key={menu.title} title={menu.title} to={menu.to||''} disabled={menu.disabled}/>; 
        } 
        return null; })} */}
      {/* <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/dashboard' />  */}
    </>
  )
}
